import { Box, type BoxProps, Divider, Stack, Typography } from "@mui/material";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import type { ReactNode } from "react";
import { Flex } from "./Core/Flex";

type DotProps = {
  color: string;
};

const Dot = ({ color, ...rest }: DotProps) => {
  return (
    <Box
      {...rest}
      sx={{
        backgroundColor: color,
        width: 12,
        height: 12,
        marginRight: Spacing.M,
        borderRadius: Radius.MAX,
        flexShrink: 0,
      }}
    />
  );
};

type RowProps = {
  color?: string;
  colorValue?: string;
  value: string;
  units?: string;
  label: string;
  labelFontWeight?: number;
};

export const SummaryCardRow = ({ label, color, value, units, colorValue = "grey.900", labelFontWeight = 400 }: RowProps) => {
  return (
    <Flex justifyContent="space-between" alignItems="center" py={Spacing.S}>
      <Flex alignItems="center">
        {color && <Dot color={color} />}
        <Typography variant="body2" fontWeight={labelFontWeight}>
          {label}
        </Typography>
      </Flex>
      <Flex gap={Spacing.S}>
        <Typography fontSize={14} fontWeight={500} color={colorValue} sx={{ whiteSpace: "nowrap" }}>
          {value}
        </Typography>
        {units && (
          <Typography fontSize={14} color={"grey.500"}>
            {units}
          </Typography>
        )}
      </Flex>
    </Flex>
  );
};

interface Props extends BoxProps {
  children: ReactNode;
  variant?: "box" | "list";
}

export const SummaryCard = ({ children, variant = "box", ...rest }: Props) => {
  return (
    <Box
      {...rest}
      py={Spacing.L}
      {...(variant === "box" && { px: Spacing.XL })}
      sx={{
        borderRadius: Radius.L,
        backgroundColor: variant === "box" ? "grey.50" : "white",
      }}
    >
      <Stack spacing={Spacing.S} {...(variant === "list" && { divider: <Divider /> })}>
        {children}
      </Stack>
    </Box>
  );
};
